import { ChangeDetectionStrategy, Component } from '@angular/core';
import { authLogout } from '@core/auth/store/auth.actions';
import { AppState } from '@core/core.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'wa-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoAccessComponent {
  constructor(private store: Store<AppState>) {}
  logOut(): void {
    this.store.dispatch(authLogout());
  }
}
